import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import CardBase from "../../bases/CardBase";
import Eyebrow from "../../../../../elements/Eyebrow";
import TwitterCardTimeline from "./TwitterCardTimeline.js";

var TwitterCard = /*#__PURE__*/function (_Component) {
  _inherits(TwitterCard, _Component);

  var _super = _createSuper(TwitterCard);

  function TwitterCard() {
    _classCallCheck(this, TwitterCard);

    return _super.apply(this, arguments);
  }

  _createClass(TwitterCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          borderless = _this$props.borderless,
          eyebrow = _this$props.eyebrow,
          timelineDataSource = _this$props.timelineDataSource,
          timelineOptions = _this$props.timelineOptions,
          id = _this$props.id;
      var getClassName = getClassNameFactory(TwitterCard.displayName);
      return /*#__PURE__*/React.createElement("div", {
        className: getClassName()
      }, /*#__PURE__*/React.createElement(CardBase, {
        borderless: borderless,
        size: "large",
        id: id
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "wrapper"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "inner"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "eyebrow"
        })
      }, /*#__PURE__*/React.createElement(Eyebrow, {
        text: eyebrow
      })), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "timeline"
        })
      }, /*#__PURE__*/React.createElement(TwitterCardTimeline, {
        timelineOptions: timelineOptions,
        timelineDataSource: timelineDataSource
      }))))));
    }
  }]);

  return TwitterCard;
}(Component);

_defineProperty(TwitterCard, "propTypes", {
  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Eyebrow to display above the timeline
   */
  eyebrow: PropTypes.string,

  /**
   * Data source for the timeline. Conforms to the [Twitter specification for createTimeline](https://dev.twitter.com/web/javascript/creating-widgets#timelines)
   */
  timelineDataSource: PropTypes.object.isRequired,

  /**
   * Display options for the timeline. Conforms to the [Twitter specification for createTimeline](https://dev.twitter.com/web/javascript/creating-widgets#timelines)
   */
  timelineOptions: PropTypes.object,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
});

_defineProperty(TwitterCard, "defaultProps", {
  timelineOptions: {
    chrome: "noheader",
    linkColor: "#005da2",
    dnt: true
  }
});

_defineProperty(TwitterCard, "displayName", "TwitterCard");

export default TwitterCard;